<template>
  <div class="header">
    <div class="header-box">
      <div class="logo-box">
        <img class="logo-img" :src="merchantStore.merchantInfo?.avatar" alt="" />
        <!-- <div class="logo-text-box">
          <div class="logo-text">连娱宝</div>
          <div class="edition-label">
            <edition-label ref="refEditionLabel" :edition="merchantStore.merchantInfo?.edition" />
          </div>
        </div> -->
      </div>

      <div class="menu-container">
        <el-menu
          :default-active="activeHeaderMenuIndex"
          class="header-el-menu"
          mode="horizontal"
          @select="handleSelect"
        >
          <template v-for="scope in scopeList">
            <!--判断菜单是否要展开-->
            <el-menu-item
              v-if="!scope.children || scope.children.length === 0"
              :key="scope.name"
              :index="scope.name"
            >
              <template #title>
                <div class="menu-title aic">
                  <icon v-if="scope.meta.icon" :icon-class="scope.meta.icon" />
                  <span class="ml-4">{{ scope.meta.title }}</span>
                </div>
              </template>
            </el-menu-item>
            <el-sub-menu
              v-else
              :key="scope.name"
              :index="scope.name"
              :show-timeout="0"
              :hide-timeout="50"
            >
              <template #title>
                <div class="aic">
                  <icon v-if="scope.meta.icon" :icon-class="scope.meta.icon"></icon>
                  {{ scope.meta.title }}
                </div>
              </template>
              <el-menu-item v-for="sub in scope.children" :key="sub.name" :index="sub.name">
                <div class="aic">
                  <icon v-if="sub.meta.icon" :icon-class="sub.meta.icon" />
                  {{ sub.meta.title }}
                </div>
              </el-menu-item>
            </el-sub-menu>
          </template>
        </el-menu>
      </div>

      <el-button color="#FFC106" class="button-logout" @click="logout">
        <icon icon-class="exit" />
        <span class="ml-5">退出登录</span>
      </el-button>

      <div class="header-userinfo">
        <el-dropdown
          class="menu-userinfo"
          :show-timeout="0"
          trigger="click"
          @visible-change="userInfoChange"
        >
          <span class="el-dropdown-link aic">
            <div class="header-username">
              <div v-if="staffInfo">{{ staffInfo.name }}</div>
              <div v-if="merchantDeviceStore.merchantDevice" class="mt-5">
                {{ merchantDeviceStore.merchantDevice.name }}
              </div>
            </div>
            <img
              :src="staffInfo?.avatar || getAssetsFile('images/logo.png')"
              class="header-avatar"
              alt=""
            />
            <icon
              v-if="isUserInfoRightIconDown"
              icon-class="el-icon-arrow-down"
              class="el-icon--right icon-user-info"
            />
            <icon v-else icon-class="el-icon-arrow-up" class="el-icon--right icon-user-info" />
          </span>

          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <div class="aic" @click="showDialogEditAccountPassword">
                  <icon icon-class="exchange" />
                  <span class="ml-5">修改密码</span>
                </div>
              </el-dropdown-item>

              <el-dropdown-item>
                <div class="aic" style="width: 100%" @click="exitApp">
                  <icon icon-class="exit" />
                  <span class="ml-5">退出程序</span>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>

      <!--切换商户-->
      <el-dialog v-model="dialogChangeVisible" title="切换空间" width="360px">
        <div class="merchant-box">
          <div
            v-for="(mch, index) in merchants"
            :key="index"
            :class="['merchant-item', merchantStore.id === mch.id ? 'active' : '']"
            @click="confirmChangeMerchant(mch.id)"
          >
            <img
              :src="mch.logo ? mch.logo : getAssetsFile('/images/empty-avatar.jpg')"
              :alt="mch.name"
              class="merchant-avatar"
            />
            <div class="merchant-info">
              <div class="merchant-name">{{ mch.name }}</div>

              <el-tag size="small" :type="ConstMerchant.map.get(mch.type)?.type" effect="dark">{{
                ConstMerchant.map.get(mch.type)?.mean
              }}</el-tag>
            </div>
            <span v-if="merchantStore.id === mch.id" class="top-rate-triangle" />
            <span v-if="merchantStore.id === mch.id" class="beata-text">当前</span>
          </div>
        </div>
      </el-dialog>
    </div>

    <DialogEditAccountPassword v-model="dialogEditAccountPasswordVisible" />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { usePermissionStore } from '@/stores/modules/permission'
import { useStaffStore } from '@/stores/modules/staff'
import { useMerchantStore } from '@/stores/modules/merchant'
import { useUserStore } from '@/stores/modules/user'
import { useMerchantDeviceStore } from '@/stores/modules/merchant-device'
import { sendPageMessage } from '@/utils/page-reload'
import { getAssetsFile } from '@/utils/index'
import ConstMerchant from '@/const/merchant'
import apiAccountMerchant from '@/api/account-merchant'
import { setMerchantId } from '@/utils/auth-merchant'
// import EditionLabel from '@/layout/components/EditionLabel/index.vue'
import DialogEditAccountPassword from '@/layout/components/DialogEditAccountPassword.vue'
import { useLockScreen } from '@/hooks/useLockScreen'

export default {
  components: { DialogEditAccountPassword },
  setup() {
    const { toggleLockScreen } = useLockScreen()
    const staffStore = useStaffStore()
    const merchantStore = useMerchantStore()
    const userStore = useUserStore()
    const merchantDeviceStore = useMerchantDeviceStore()
    return {
      staffInfo: staffStore.staffInfo,
      merchantStore,
      userStore,
      merchantDeviceStore,
      toggleLockScreen
    }
  },
  data() {
    return {
      ConstMerchant,

      activeHeaderMenuIndex: 'platform',
      isUserInfoRightIconDown: true,

      keyword: '',

      // 切换酒吧
      dialogChangeVisible: false,
      merchants: [],
      dialogEditAccountPasswordVisible: false,
      dialogPrintTransferReceiptVisible: false
    }
  },
  computed: {
    ...mapState(usePermissionStore, ['routerScope', 'scopeList'])
  },
  watch: {
    /**
     * 监听当前 active 的作用域路由（顶部菜单），当发生变更时，修改顶部菜单激活的元素
     */
    routerScope() {
      this.activeHeaderMenuIndex = this.routerScope
    },

    $route(val) {
      console.log('route', val)
    }
  },
  mounted() {
    // 初始化头部菜单栏选中
    this.activeHeaderMenuIndex = this.routerScope
  },
  methods: {
    getAssetsFile,

    handleSelect(selectedIndex) {
      // 选中当前的菜单，直接返回
      if (this.activeHeaderMenuIndex === selectedIndex) {
        return
      }
      this.activeHeaderMenuIndex = selectedIndex
      const permissionStore = usePermissionStore()
      permissionStore.changeRouterScope({
        scope: selectedIndex,
        pushFirstRouter: true
      })
    },

    userInfoChange(isShow) {
      this.isUserInfoRightIconDown = !isShow
    },

    /**
     * 退出登录
     */
    async logout() {
      // 退出登录
      this.userStore.logout()
      this.$router.replace('/login')
    },

    /**
     * 切换商户
     */
    changeMerchant() {
      // this.getAvailableMerchants()
      // this.dialogChangeVisible = true
    },

    /**
     * 当前有权限的商户
     */
    getAvailableMerchants() {
      apiAccountMerchant
        .availableMerchants()
        .then((res) => {
          this.merchants = res.data.list
        })
        .catch((e) => {
          console.log(e)
        })
    },

    /**
     * 确定切换商户
     */
    confirmChangeMerchant(merchantId) {
      if (merchantId === this.merchantStore.id) {
        this.$message.info({
          message: '当前已在 [' + this.merchantStore.merchantInfo.name + ']，无需切换。',
          duration: 1000
        })
        return
      }
      setMerchantId(merchantId)
      this.$message.success('操作成功，切换中...')
      // window.location.reload()
      sendPageMessage() // 通知其他同源页面刷新
    },

    /**
     * 展示版本介绍
     */
    showEditionIntro() {
      this.$refs.refEditionLabel.showEditionIntro()
    },

    /**
     * 退出应用
     */
    exitApp() {
      this.$confirm('确定退出程序？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.logout()
          window?.electron?.exitApp()
        })
        .catch(() => {})
    },

    showDialogEditAccountPassword() {
      this.dialogEditAccountPasswordVisible = true
    }
  }
}
</script>
<style lang="scss">
.header .el-menu--horizontal .el-submenu .el-submenu__title {
  border-bottom: none !important;
  height: 33px;
  line-height: 33px;
}

.header .el-menu {
  background-color: transparent;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../styles/variables.scss';
.header {
  height: 50px;
  width: 100%;
  background-color: $background-color-1;
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.08);

  .header-box {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .logo-box {
    display: flex;
    align-items: center;
    padding: 0 10px;
    margin-right: 0;
    margin-top: 2px;
    height: 100%;

    .logo-img {
      width: 32px;
      height: 32px;
      border-radius: 4px;
    }

    .logo-text-box {
      margin-left: 8px;

      .edition-label {
        transform: scale(0.7);
        display: flex;
        margin-left: -9px;
        margin-top: -2px;
      }
    }

    .logo-text {
      color: white;
      font-size: 14px;
      font-weight: bold;
      //letter-spacing: 1px;
    }
  }

  .menu-container {
    flex: 1;
    .el-menu.el-menu--horizontal {
      border: none;
    }
  }

  .search-box {
    width: 280px;
    margin-left: 20px;
    padding-top: 9px;
  }

  .header-el-menu {
    margin-left: 10px;

    .el-menu-item {
      border-bottom: none !important;
    }
  }

  &.dark {
    background-color: #0f0c3a;

    .logo-box {
      .logo-img {
        //border: 1px solid rgba(255, 255, 255, 0);
      }
      .logo-text {
        color: rgba(255, 255, 255, 0.75) !important;
      }
    }

    .header-username,
    .icon-user-info {
      color: rgba(255, 255, 255, 0.75);
    }
  }
}

.header .el-menu--horizontal > .el-menu-item.is-active,
.header-el-menu .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}

.header .el-menu--horizontal > .el-menu-item {
  height: 33px;
  line-height: 33px;
  margin-right: 5px;
  i {
    font-size: 16px;
  }

  /*color: #666 !important;*/
  padding: 0 10px;
  border-radius: 3px;
  color: $text-color-3 !important;
  i {
    color: $text-color-3 !important;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    color: $text-color-1 !important;

    i {
      color: $text-color-1 !important;
    }
    //color: rgba(255, 255, 255, 0.75) !important;
    //i {
    //  color: rgba(255, 255, 255, 0.75) !important;
    //}
  }
}

.header.dark .el-menu--horizontal > .el-menu-item {
  /*color: #666 !important;*/
  padding: 0 10px;
  border-radius: 3px;
  color: rgba(255, 255, 255, 0.75) !important;
  i {
    color: rgba(255, 255, 255, 0.75) !important;
  }

  &:hover {
    //background-color: rgba(255, 255, 255, 0.15);

    color: white !important;
    i {
      color: white !important;
    }
  }
}

.header .el-menu--horizontal > .el-menu-item.is-active {
  /*font-weight: bold;*/
  border-radius: 3px;

  //background-color: rgba(255, 255, 255, 0.15);
  //background-color: rgba(255, 0, 137, .06);
  font-weight: bold;
  color: $text-color-1 !important;
  i {
    color: $text-color-1 !important;
  }

  &:focus {
    background-color: transparent;
  }
  &:hover {
    i {
      color: $text-color-1 !important;
    }
    color: $text-color-1 !important;
  }
}

.header.dark .el-menu--horizontal > .el-menu-item.is-active {
  color: white !important;
  i {
    color: white !important;
  }

  &:focus {
    background-color: rgba(255, 255, 255, 0.15);
  }
  &:hover {
    i {
      color: white !important;
    }
    color: white !important;
  }
}

/*头部用户信息*/
.header-userinfo {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.button-logout {
  color: #ffffff;
  margin-right: 20px;
}

.header-avatar {
  display: inline-block;
  vertical-align: middle;
  width: 30px;
  height: 30px;
  border-radius: $radius;
  margin-right: 5px;
}

.header-username {
  margin-left: 10px;
  margin-right: 10px;
  text-align: right;
}

.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
  border: 0 !important;
  outline: none !important;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.website {
  text-align: right;
  padding: 10px;
  a {
    color: #333;
    font-size: 14px;
    margin: auto 10px;
  }
  a:hover {
    color: #333;
  }
}

.icon-user-info {
  display: inline-block;
  font-size: 12px;
}

.slogan {
  color: #666666;
  font-size: 12px;
}

.merchant-box {
  margin-top: 15px;
}

.merchant-item {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-basis: 250px;
  margin-bottom: 15px;
  padding: 15px;
  border: 1px solid #efefef;
  border-radius: 5px;
  overflow: hidden;
  &.active {
    border: 1px solid $color-theme;
    background-color: $color-bg;
  }

  &:hover {
    border: 1px solid $color-theme;
    cursor: pointer;
  }

  .beata-text {
    position: absolute;
    top: 7px;
    right: 2px;
    z-index: 99;
    font-size: 12px;
    transform: rotate(45deg);
    color: white;
  }

  .top-rate-triangle {
    width: 0;
    height: 0;
    border-top: 40px solid $color-theme;
    border-left: 40px solid transparent;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
  }
}

.merchant-avatar {
  width: 48px;
  height: 48px;
  border-radius: 5px;
}

.merchant-info {
  margin-left: 15px;

  .merchant-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    margin-top: 5px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
